import { ButtonClose } from "@lk-gtcom/ecomlab-components"
import { TitlePage } from "../../TitlePage/TitlePage"
import { TextPage } from "../../TextPage/TextPage"
import './ModalError.scss'

const ModalError = ({ headerText, messageText, setShowModal }) => {

    return (
        <div className='blackout' onClick={(e) => {
            let el = e.target
            if (el.classList.contains('blackout')) {
                setShowModal(false)
            }
        }}>
            <div className='modal-error'>
                <div className='modal-error__header'>
                    <TitlePage
                        title='Ошибка'
                    />

                    <ButtonClose
                        onClick={(e) => {
                            setShowModal(false)
                        }}
                    />
                </div>
                <div className='modal-error__content'>
                    {headerText && <TitlePage
                        style={{ color: 'red' }}
                        medium
                        title={headerText}
                    />}

                    {messageText && <TextPage
                        style={{ color: 'red' }}
                        text={messageText}
                    />}
                </div>
            </div>
        </div>
    )
}

export default ModalError